import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';

export const ButtonLink = ({
  label,
  variant,
  fullwidth,
  wide,
  size,
  ...rest
}) => (
  <Link
    className={cx(
      styles.btn,
      fullwidth && styles.fullwidth,
      wide && styles.wide,
      styles[variant],
      styles[size],
    )}
    {...rest}
  >
    <span>{label}</span>
  </Link>
);

ButtonLink.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'link',
    'primary-outline',
    'secondary-outline',
  ]),
  fullwidth: PropTypes.bool,
  wide: PropTypes.bool,
  size: PropTypes.oneOf(['', 'lg']),
};

ButtonLink.defaultProps = {
  label: '',
  variant: 'primary',
  fullwidth: false,
  wide: false,
  size: '',
};
